import { render, staticRenderFns } from "./hisEditOpinion.vue?vue&type=template&id=0a7d34c2&scoped=true"
import script from "./hisEditOpinion.vue?vue&type=script&lang=js"
export * from "./hisEditOpinion.vue?vue&type=script&lang=js"
import style0 from "./hisEditOpinion.vue?vue&type=style&index=0&id=0a7d34c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d34c2",
  null
  
)

export default component.exports